(function() {
  "use strict";
  angular.module("marketPlace.category", []);
})();
